










































import { Event } from '@ssp/inscreva-sse-models';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class EventInfoNotification extends Vue {
  @Prop({ required: true })
  event!: Event;
}
